/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.5",
    versionName: "0.2.0-nightly.2025.8.5",
    versionChannel: "nightly",
    buildDate: "2025-08-05T00:08:11.093Z",
    commitHash: "09c2d48e188d78ceb9525b61b9ec45ddfadefdf1",
};
